import moment from 'moment'
import numeral from 'numeral'

export const formatarCpf = (value) => {
  if (
    typeof value === 'undefined' ||
    value === '' ||
    `${value}`.length !== 11
  ) {
    return ''
  }

  const cpf = value.toString().replace(/[^\d]/g, '')
  const regex = /^([\d]{3})([\d]{3})([\d]{3})([\d]{2})$/
  return cpf.replace(regex, '$1.$2.$3-$4')
}

export const formatarCnpj = (value) => {
  if (
    typeof value === 'undefined' ||
    value === '' ||
    `${value}`.length !== 14
  ) {
    return ''
  }

  const cnpj = value.toString().replace(/[^\d]/g, '')
  const regex = /^([\d]{2})([\d]{3})([\d]{3})([\d]{4})([\d]{2})$/
  return cnpj.replace(regex, '$1.$2.$3/$4-$5')
}

export const formatarData = (value, format, noUtc) => {
  if (!value) {
    return 'Não informado'
  }

  return noUtc
    ? moment(value).format(format)
    : moment(value).utc().format(format)
}

export const statusBloqueioPagamento = (bloqueadoParaPagamento) => {
  return bloqueadoParaPagamento ? 'BLOQUEADO' : 'NÃO BLOQUEADO'
}

export const primeiraLetraMaiuscula = (value = '') => {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const limitar = (value = '', limit = 0) => {
  return value.substring(0, limit)
}

export const iniciarEm = (value = '', start = 0) => {
  return value.slice(start)
}

export const caixaAlta = (value = '') => {
  return value.toUpperCase()
}

export const formatarNumero = (value) => {
  return numeral(value).format('0,0.00')
}

export const formatarDinheiro = (value) => {
  return numeral(value / 100).format('0,0.00')
}
